if(! Element.getPosition) {
	Element.prototype.getPosition = function() {
		let element = this;
		let top = element.offsetTop;
		let left = element.offsetLeft; 
		
		while( element.offsetParent ) {
			element = element.offsetParent;
			top += element.offsetTop;
			left += element.offsetLeft; 
		}
		
		return { left, top };
	}
}